import createCrud from './crud';
import modules from './stacks/index'

export default createCrud({
  resource: 'stacks', modules
});